import { inheritActionOwner, isActionCurrent } from '@/_core/fluxstore/dispatchOwnership';
import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { AddNewSubtask } from './addNewSubtask';
import { SaveNewSubtask } from './saveNewSubtask';
import { createDebugger } from '@/_core/utils/debug';

const debug = createDebugger('pages:main:storymap:store:actions:newCard:addSubtaskFromAi');
const { registerMiddleware, dispatch } = useStorymapStore();

export class AddSubtaskFromAi extends Action<StorymapState> {
    public static ACTION_TYPE = 'AddSubtaskFromAi';
    public _cardId: string;

    public constructor(public taskId: string, public title: string, public releaseId: string = null, public description: string = null) {
        super(AddSubtaskFromAi.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: AddSubtaskFromAi): Promise<boolean> => {
    debug('AddSubtaskFromAi start', action);

    const order = state.subtasks.filter((x) => x.taskId === action.taskId && x.releaseId === action.releaseId).length;

    const addAction = inheritActionOwner(action, new AddNewSubtask(action.taskId, action.releaseId, order, true));
    await dispatch(addAction);
    if (!isActionCurrent(action)) return false;
    action._cardId = addAction._cardId;
    await dispatch(inheritActionOwner(action, new SaveNewSubtask(action._cardId, action.title, action.description)));
    if (!isActionCurrent(action)) return false;

    debug('AddSubtaskFromAi end', action);

    return true;
};

//@ts-ignore
registerMiddleware(AddSubtaskFromAi.ACTION_TYPE, middleware);
